// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo {\n  width: 24px;\n  height: 22px;\n  margin-bottom: -4px;\n  margin-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
